/**
 * Financa 1 = erp_url_backup, Financa 2 = erp_url.
 * product.financa_sync comes from create/edit: { financa_1, financa_2, skipped }.
 */
export function productFinancaSaveNotice(action, product) {
  const prefix = action === "create"
    ? "Produkti u krijua me sukses."
    : "Produkti u modifikua me sukses.";
  const sync = product?.financa_sync;
  const saved1 = sync?.financa_1;
  const saved2 = sync?.financa_2;

  if (saved1 === true && saved2 === true) {
    return { level: "success", text: `${prefix} U ruajt në Financa 1 dhe Financa 2.` };
  }
  if (saved1 === true && saved2 === false) {
    return { level: "warning", text: `${prefix} U ruajt në Financa 1, por nuk u ruajt në Financa 2.` };
  }
  if (saved1 === false && saved2 === true) {
    return { level: "warning", text: `${prefix} U ruajt në Financa 2, por nuk u ruajt në Financa 1.` };
  }
  if (saved1 === false && saved2 === false) {
    return { level: "warning", text: `${prefix} Nuk u ruajt as në Financa 1, as në Financa 2.` };
  }
  if (sync?.skipped) {
    return { level: "success", text: prefix };
  }
  if (Number(product?.fis_status) === 1) {
    return { level: "success", text: `${prefix} Ruajtur ose sinkronizuar me F5.` };
  }
  return { level: "warning", text: `${prefix} Kujdes: nuk u ruajt / nuk u sinkronizua me F5.` };
}

/** backup = Financa 1, live = Financa 2. */
export function financaServerLabel(erp) {
  if (erp === "backup") return "Financa 1";
  if (erp === "live") return "Financa 2";
  return erp || "—";
}

/** failed_sync rows use erp "backup" (Financa 1) and "live" (Financa 2). */
export function financaTargetsFailureText(failedRows) {
  const rows = Array.isArray(failedRows) ? failedRows : [];
  const erps = new Set(rows.map((row) => row?.erp).filter(Boolean));
  const failed1 = erps.has("backup");
  const failed2 = erps.has("live");
  if (failed1 && failed2) return "Nuk u ruajt as në Financa 1, as në Financa 2.";
  if (failed2 && !failed1) return "U ruajt në Financa 1, por nuk u ruajt në Financa 2.";
  if (failed1 && !failed2) return "U ruajt në Financa 2, por nuk u ruajt në Financa 1.";
  return "Nuk u ruajt në Financa.";
}

/** Group failed_sync rows so a bulk save can say which Financa missed. */
export function financaBulkFailureText(failedRows) {
  const byProduct = new Map();
  for (const row of failedRows || []) {
    const id = String(row?.product_id || row?.code || "");
    if (!id) continue;
    if (!byProduct.has(id)) byProduct.set(id, new Set());
    if (row?.erp) byProduct.get(id).add(row.erp);
  }
  let only1 = 0;
  let only2 = 0;
  let both = 0;
  for (const erps of byProduct.values()) {
    const failed1 = erps.has("backup");
    const failed2 = erps.has("live");
    if (failed1 && failed2) both += 1;
    else if (failed1) only1 += 1;
    else if (failed2) only2 += 1;
  }
  const parts = [];
  if (only2) parts.push(`${only2} u ruajtën në Financa 1, por nuk u ruajtën në Financa 2`);
  if (only1) parts.push(`${only1} u ruajtën në Financa 2, por nuk u ruajtën në Financa 1`);
  if (both) parts.push(`${both} nuk u ruajtën as në Financa 1, as në Financa 2`);
  return parts.join(". ");
}
